import { cloneDeep, isEmpty,isArray,debounce, has, set} from 'lodash';
import React, { useEffect, useState, useContext, useMemo, useRef, useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector,useDispatch } from 'react-redux';
import { FormControl, TextField, Stack, InputLabel, Select, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions,Autocomplete,Box, CircularProgress } from '@mui/material';
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import Tree from 'rc-tree';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DelimiterDialog from '../../TemplateProperties/DelimiterDialog';
import {eachDeep} from 'deepdash-es/standalone';
import { treeActions } from '../../../redux/slices/treeSlice';
import RecordMappingContextMenu from '../../ContextMenu/RecordMappingContextMenu';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { t } from "i18next";
import { genericRules, validateOnFlow, validateRevertTime, validationTime } from '../../../utils/validate';
import { api, useGetSegmentIdsQuery } from "../../../redux/api";
import DatePattern from '../PatternModal/DatePattern';
import ItemPropertiesDelimiterInput from '../ItemPropertiesDelimiterInput';
import EDIRecordProperty from './DataTypeComponents/EDIRecordProperty';
import { getNewRecordName, getUpdatedData } from '../../RightContextMenu/ContextActions/NewRecord';
import ErrorModal from './FieldDataValidation/ErrorModal';
import { StylingObject } from '../../../constants/styles';
import { scrollToSelectedItem } from '../../../utils/utilFunctions';
import DelimiterInput from '../../TemplateProperties/DelimiterInput';
import { lgDocPath } from '../../../constants/languageDocPaths';
import RegularExpressionDialog from './RegularExpressionDialog';
// const noop = () => void 0

// export const AlertDialog = ({
//     open = false,
//     onClose = noop,
//     message = ''
// }) => {
//     return  <Dialog maxWidth={'sm'} open={open} onClose={onClose}>
//     <DialogTitle className="dialog-header">
//         <div className="title">Warning</div>
//     </DialogTitle>
//     <DialogContent className="dialog-content" dividers>
//         <Typography variant="subtitle1" px={3} py={2}>
//             {message}
//         </Typography>
//     </DialogContent>
//     <DialogActions>
//         <Button
//             variant="outlined"
//             color="primary"
//             onClick={onClose}>
//             OK
//         </Button>
//     </DialogActions>
//     </Dialog>
// }



  const validateFields = [
    'TITLE',
    'LBL_START_POSITION',
    'LBL_RECORD_LENGTH',
    'LBL_NUM_OF_CHARS',
    'LBL_START_OCCUR',
    'LBL_END_OCCUR'
  ];
  

  const validationRules = {
    TITLE: genericRules.noSlashRule,
    LBL_START_POSITION: genericRules.numericRule,
    LBL_RECORD_LENGTH: genericRules.numericRule,
    LBL_NUM_OF_CHARS: genericRules.numericRule,
    LBL_START_OCCUR: genericRules.numericRule,
    LBL_END_OCCUR: genericRules.numericRule
  };

  const portioningType = {
    BTN_EXACT_PORTIONING: 
    ['LBL_FROM', 
    'LBL_START_POSITION', 
    'LBL_NUM_OF_CHARS'],
    BTN_REL_PORTIONING: [
    'LBL_PARSE_FROM',
    'LBL_START_VAL',
    'LBL_END_VAL',
    'LBL_START_OCCUR',
    'LBL_END_OCCUR']
  }

const CustomTextField = (props) => {
    const [shrink, setShrink] = useState(false);
    const {onBlur, onChange, value = "", ...rest} = props;
    useEffect(() => {
        if(value.toString().length > 0)
            setShrink(true);
    },[])
    return <TextField
    onChange={(event) => {
        setShrink(true);
        onChange(event)
    }}
    onBlur={(event) => {
        setShrink(true);
        onBlur(event)
    }}
    value={value}
    InputLabelProps={{shrink}}
    {...rest}
/>
}

function RecordPropertyForm() {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { account, user, baseUrl, lang } = useSelector((state) => state.queryParams);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;
    const mappingRef = useRef();
    const comparatorRef = useRef();
    const dispatch = useDispatch();

    // Properties
    const [recordName, setRecordName] = useState('');
    const [recordLength, setRecordLength] = useState(0);
    const [fields, setFields] = useState([]);
    const [delimiter, setDelimiter] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [delimDialogValue, setDelimDialogValue] = useState('');
    const [selectedByClick,setSelectedByClick] = useState(false);
    const [recordMappingTreeData, setRecordMappingTreeData] = useState([]);
    const [selectedRecordMapNode, setSelectedRecordMapNode] = useState({});
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [fieldSelectedKeys, setFieldSelectedkeys] = useState([]);
    const [fieldExpandedKeys, setFieldExpandedKeys] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [date, setDate] = useState('MM/dd/yy');
    const [pattern,setPattern] = useState('MM/dd/yy');
    const [datePatternModal, setDatePatternModal] = useState(false);
    const [datePattern, setDatePattern] = useState('');
    const [startPosition,setStartPosition] = useState('');
    const [numberChar,setNumberChar] = useState('');
    const [startVal,setStartVal] = useState('');
    const [endVal,setEndVal] = useState('');
    const [valid,setValid] = useState(true);
    const [dpNetworkCallMessage,setDpNetworkCallMessage] = useState('')
    const [isMounted, setIsMounted] = useState(false);
    const [errors, setErrors] = useState({});
    const [error,setError] = useState('');
    const [errorModal,setErrorModal] = useState(false);
    const [testResult, setTestResult] = useState('');
    const [flag,setFlag] = useState(false);
    const [hl7SegmentId,setHL7SegmentId]= useState('');
    const [fieldDelimiter, setFieldDelimiter] = useState(false);
    const [segmentOptions,setSegmentOptions] = useState([t('SELECT')]);
    const [fixedLengthRecord, setFixedLengthRecord] = useState(false)
    const [validateDatePatternLoading, setValidateDatePatternLoading] = useState(false);
    const [portioningResultLoading, setPortioningResultLoading] = useState(false)
    const hl7SegmentIdOptions = useGetSegmentIdsQuery({
      account,
      report_type: "hl7",
      version: templateHeader?.FILETYPE_VERSION
})
// Adding the "--select--" option to the HL7 segment ID dropdown
   useEffect(()=>{
      setSegmentOptions([t('SELECT'), ...hl7SegmentIdOptions.data?.data || []]);
    },[hl7SegmentIdOptions])
   
    const [openRegExDialog,setOpenRegExDialog] = useState(false);
    const errorRef = useRef(new Object());
    const newCreationRef = useRef(false);
    useEffect(() => {
        setTestResult('');
        setErrors({});
        setComparatorField([]);
        if (selectedNode) {
            updateFields(selectedNode)
            setRecordName(prev => selectedNode.TYPE || '')
            // setPattern(selectedNode?.PATTERN || 'MM/dd/yy');
            setRecordMappingTreeData(selectedNode.CONDITION || [])
            setHL7SegmentId(selectedNode?.FIELD?.VALUE || segmentOptions[0])
            setSelectedKeys(['rmp-0']);
            setExpandedKeys([]);
            setFixedLengthRecord(selectedNode?.FIXED_LENGTH === 'TRUE' || false)
        }
    }, [selectedNode?.key,rightTree.currentTab]); // keys maybe same in header trailer and body;
    


    // Dropdowns
    const operatorsDropdowns = [
        { value: 'EMPTY', text: t('EMPTY') },
        { value: 'EQUALS', text: t('EQUALS') },
        { value: 'CONTAINS', text: t('CONTAINS') },
        { value: 'STARTS_WITH', text: t('STARTS WITH') },
        { value: 'ENDS_WITH', text: t('ENDS WITH') },
        { value: 'GREATER_THAN', text: t('GREATER THAN') },
        { value: 'LESS_THAN', text: t('LESS THAN') },
        { value: 'GREATER_THAN_OR_EQUAL', text: t('GREATER THAN OR EQUAL') },
        { value: 'LESS_THAN_OR_EQUAL', text: t('LESS THAN OR EQUAL') },
        { value: 'IS_RECORD_NUMBER', text: t('IS RECORD NUMBER') },
        { value: 'IS_NUMERIC', text: t('IS NUMERIC') },
        { value: 'IS_DATE', text: t('IS DATE') },
        { value: 'FIELD_LENGTH_GREATER_THAN', text: t('FIELD LENGTH GREATER THAN') },
        { value: 'FIELD_LENGTH_LESS_THAN', text: t('FIELD LENGTH LESS THAN') },
        { value: 'REGULAR_EXPRESSION', text: t('REGULAR EXPRESSION') },
        { value: 'TRUE', text: t('TRUE') },
        { value: 'FALSE', text: t('FALSE') },
    ];
    
    const valueToCompareVisibleItems =['EQUALS','CONTAINS','STARTS_WITH','ENDS_WITH','IS_DATE','IS_NUMERIC','REGULAR_EXPRESSION'];

    // const scopesDropdown = [
    //     { value: t('FIELD'), text: t('FIELD') },
    //     { value: t('RECORD'), text: t('RECORD') }
    // ];

    const scopesDropdown = [
        { value: 'FIELD', text: t('FIELD') },
        { value: 'RECORD', text: t('RECORD')}
    ];

    const scopesDropdownNVP = [
      { value: 'RECORD', text: t('RECORD')}
  ];

    const fromRelativeDropdowns = [
        { value: 'LEFT', text: t('PARSELEFT') },
        { value: 'RIGHT', text: t('PARSERIGHT') }
    ];

    const fromExactDropdowns = [
        { value: 'LEFT', text: t('LEFT') },
        { value: "RIGHT", text: t('RIGHT') }
    ];
    // Creating dropdown items
    const operators = useMemo(() => operatorsDropdowns?.map((obj, key) =>
    <MenuItem key={key} value={obj.value}>
        {obj.text}
    </MenuItem>
    ), [operatorsDropdowns]);

    // const scopes = scopesDropdown?.map((obj, key) =>
    //     <MenuItem key={key} value={obj.value}>
    //         {obj.text}
    //     </MenuItem>
    // );

    const fromsRelative = useMemo(() => fromRelativeDropdowns.map((obj, key) =>
    <MenuItem key={key} value={obj.value}>
        {obj.text}
    </MenuItem>
    ), [fromRelativeDropdowns]);

    const fromsExact = useMemo(() => fromExactDropdowns.map((obj, key) =>
    <MenuItem key={key} value={obj.value}>
        {obj.text}
    </MenuItem>
    ), [fromExactDropdowns]);
    
    
     const handleModal = () => {
        setModalOpen(true);
    }
    const handleRegExModal =() =>{
      setOpenRegExDialog(true); 
    }
    const toggle = () => {
        setModalOpen(false);
    }

    const updateFields = (node) => {
      // Changed for FIELDS GROUP supported Datatypes;
      const expandedKeys = [];
      const getNodes = (data = [],key) =>{
        return data.filter(child => child.ICON_DISPLAY.includes('FIELD'))?.map((ele,idx)=>{
          const newKey = `${key}-${idx}`
          let children = ele.children
          if(ele.ICON_DISPLAY.includes('FIELD_GROUP')) expandedKeys.push(newKey);
          const title = ele?.ICON_DISPLAY.includes('FIELD_GROUP') ? ele?.TYPE : ele?.title;
          if(ele?.children?.length) children =getNodes(ele.children,newKey);
          return {
            ...ele,
            key:newKey,
            title:title,
            children,
            FIELDNUM: idx + 1
          };
        })
      }
      setFieldExpandedKeys(expandedKeys);
      setFields(getNodes(node?.children,`cf`))
    }

    const Icon = (node) => {
        return <span data-key={`${node?.key}`} className={'tree-icon ' + node.ICON_DISPLAY}></span>
    }
    const titleRender = (node) => {
        return <span data-key={`${node?.key}`}>{node.title}</span>
    }
    
    const switcherIcon = (obj) => {
        if (obj.isLeaf) return;
        if (obj.expanded) return <ArrowDropDownIcon />
        else return <ArrowRightIcon sx={{color: '#666666'}}/>
    }
    const recordMappingRCTree = useMemo(() => rmDataTransformer.toRCTree(recordMappingTreeData,templateHeader?.FILETYPE), [recordMappingTreeData]);
    
    const submitChange = (key, val)=>{
    const splitKeys = selectedNode.key.split("-");
    const [_, ...restSplit] = splitKeys;
    const count = restSplit.length;
    let data = JSON.parse(JSON.stringify(translatedData));
    let copyData = data;
    for(let i= 0; i < count; i++){
          if(selectedNode.key === copyData.key) break;
          else {
            copyData = copyData[restSplit[i]];
            if(i !== count - 1) copyData = copyData.children;
          }
    }

    if(key === "recordName"){
      copyData.title = val;
      copyData.TYPE = val;
    } else if(key === "FIXED_LENGTH"){
      copyData[key] = val;
    }

    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: data,
      })
    );
      // setRecordName(val);
    }

    const delimDisplay = (val, modal) => {
    
        // Display values in certain ways depending on a few specific conditions:
        // - If no delim val -> 'No Delimiter Chosen'.
        // - Replace 'CR' and 'LF' (ascii 13 and 10) OR '%0D' '%0A' -> display 'CR', 'LF', 'CRLF' in latin characters.
        // - If val is one or two char length -> display 'ASCII 42 (*)' delimited by comma.
        // - else -> display the decoded string (even if it's just empty chars ?)
        if(val === undefined) return '';
        if (!modal) {
          if (typeof val === 'boolean'|| val === t('TXT_NO_DELIM_CHOSEN') || !val) return "";
        }
        // Handle empty/null values for modal
        if (!val && val !== 0) return '';
        if (val === "CR" || val === "%0D" || val === "\r") return "CR";
        if (val === "LF" || val === "%0A" || val === "\n" ) return "LF";
        if (val === "CRLF" || val === "%0D%0A") return "CRLF";
        const crlfIndex = val.indexOf('%0D%0A');
        if (crlfIndex !== -1) {
          // Handle the case where val includes %0D%0A(CRLF)
          const beforeCRLF = decodeURIComponent(val.substring(0, crlfIndex));
          const afterCRLF = decodeURIComponent(val.substring(crlfIndex + 6));
          return beforeCRLF + 'CRLF' + afterCRLF;
        }
        
        let decodedVal = val;
        try { 
          decodedVal = decodeURIComponent(val);
        } 
        catch (e) { 
          //case - malformed URI
          //console.log(`delimDisplay - URI malformed, can not decode - ${props.label} '${val}' - Displaying raw.`) 
        }
        
        // Check for CRLF pattern in decoded value
        if (decodedVal === "\r\n") return "CRLF";
        if (decodedVal === "\r") return "CR";
        if (decodedVal === "\n") return "LF";
        
        // Handle mixed strings containing CRLF patterns
        if (decodedVal.includes('\r\n')) {
          return decodedVal.replace(/\r\n/g, 'CRLF').replace(/\r/g, 'CR').replace(/\n/g, 'LF');
        }
        if (decodedVal.includes('\r')) {
          return decodedVal.replace(/\r/g, 'CR');
        }
        if (decodedVal.includes('\n')) {
          return decodedVal.replace(/\n/g, 'LF');
        }
    
        return decodedVal;
      }

    const setTranslatedData = debounce((name, value) => {
      const splitKeys = selectedNode.key.split("-");
      const [_, ...restSplit] = splitKeys;
      const count = restSplit.length;
      let data = JSON.parse(JSON.stringify(translatedData));
      let copyData = data;
      for(let i= 0; i < count; i++){
            if(selectedNode.key === copyData.key) break;
            else {
              copyData = copyData[restSplit[i]];
              if(i !== count - 1) copyData = copyData.children;
            }
      }
      copyData[name] = value;
      
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: data,
        })
      );
      dispatch(treeActions.setRightTreeSelectedNode({
        screen:parentScreen,
        type:rightTree.currentTab,
        data:copyData
      }))
    }, 300);

    const debounceChangeHandler = debounce(submitChange, 500);


    const debounceNameChangeHandler = useCallback(debounce(submitChange, 500), [
      rightTree.currentTab,
      rightTree.tree,
    ]);


    const recordNameChange = (event) => {
            const previousValue = recordName;
            const {name , value} = event.target;
            setRecordName(prev => event.target.value);
            const errorState = validateOnFlow(name, value, validationRules);
            const isEmptyObj = isEmpty(errorState);

            if (isEmpty(errorState)) debounceNameChangeHandler('recordName',value); 

            setErrors((previous) => {
              let copyPrevious = JSON.parse(JSON.stringify(previous));
              if(isEmptyObj)
                  delete copyPrevious?.[event.target.name]
              else {
                  copyPrevious = {
                      ...copyPrevious,
                      ...errorState
                  }
              }
              return copyPrevious;
            })

            if(!isEmpty(errorState)){
              setTimeout(()=>{
                setRecordName((prev) => {
                  let val = prev;
                  val = val.replaceAll('/', '');
                  return val;
                })
              },validateRevertTime)

              if(errorRef?.current?.[name])clearTimeout(errorRef?.current[name]);
              const timerId= setTimeout(() => {
                setErrors((prev) => {
                  const copyPrev = JSON.parse(JSON.stringify(prev));
                  delete copyPrev[name];
                  return copyPrev;
                })
              }, validationTime)
              errorRef.current = {...errorRef.current , [name] : timerId}
              return;

            }            
    }

    const onRecordBlur = (event) => {
        //Commenting this out until bug ticket BG-8676 is resolved.
        // -Hunter
        const {value ,name} = event.target;
        const isDuplicate =  isDuplicateName(rightTree.tree,value,selectedNode);
        const isInvalid = (value?.toLowerCase() === "header" || value?.toLowerCase() === "trailer") 
        && rightTree.currentTab === "body" && selectedNode?.key?.split('-')?.length === 3;
        setErrors((previous) => {
          let copyPrevious = JSON.parse(JSON.stringify(previous));
          if(isDuplicate) copyPrevious[name] = `${value} ${t('_ERR_ALREADY_EXISTS')}`;
          if(isInvalid) copyPrevious[name] = `${value} ${t('RECORD_NAME_CANNOT_BE_HEADER_OR_TRAILER')}`;
          else {
              delete copyPrevious?.[name];
          }
          return copyPrevious;
        })

        if(isDuplicate){
          if(errorRef?.current?.[name]) clearTimeout(errorRef?.current[name]);
          const timerId= setTimeout(() => {
            setErrors((prev) => {
              const copyPrev = JSON.parse(JSON.stringify(prev));
              delete copyPrev[name];
              return copyPrev;
            })
          }, validationTime)
          errorRef.current = {...errorRef.current , [name] : timerId}
        }

        
        let finalValue = (!isDuplicate && value) ? value : getNewRecordName(rightTree.tree);// To Get Record Name in Sequence wise.
        finalValue = isInvalid ? getNewRecordName(rightTree.tree) : value;// To Get Record Name in Sequence wise.
        setRecordName(finalValue);
        debounceNameChangeHandler('recordName',finalValue); 
        event.stopPropagation();
    }
    const addNewRecordMap = async () => {
        setTestResult('');
        newCreationRef.current = true; // This Ref will handle Scrolling of div
        let compoundPointer = -1,posSplit = [],expandKey;
        if(selectedRecordMapNode &&(
           selectedRecordMapNode.NAME === 'COMPOUND CONDITION' ||
           selectedRecordMapNode.TYPE === 'COMPOUND_COMPOUND_MAPPING' ||
           selectedRecordMapNode.TYPE === 'COMPOUND_RECORD_MAPPING')
           ){
            posSplit = selectedRecordMapNode.key.split("-");
            compoundPointer = +posSplit[posSplit.length - 1];
        }

        let copyPrevious = JSON.parse(JSON.stringify(recordMappingTreeData));
        if(compoundPointer === -1){
            copyPrevious =  [...copyPrevious, {
                COMPARE: "EMPTY",
                COMPARE_ACTION_IGNORECASE: "FALSE",
                COMPARE_ACTION_NOT:  "TRUE",
                LEVEL: templateHeader?.FILETYPE === "NVP" ? 'RECORD' : "FIELD",
                NAME: `UNNAMED`,
                RECORDTYPE: selectedNode?.title || "",
                VALUE: "",
                PATTERN:"",
                FIELD_NAME: fields?.[0]?.MAPNAME || undefined,
                MAPNAME: fields?.[0]?.MAPNAME || undefined,
                FIELDNUM: fields?.length ? 1 : undefined 
            }]
        }
        const [_, firstIndex, ...restSplit] = posSplit;
        let findTree = copyPrevious;
        findTree = findTree.find((_, index) => index === +firstIndex);
        const count = restSplit.length;
        var element;
        findTree = findTree?.CONDITION;
        for(let i = 0; i < count; i++){
            element = findTree.find((_, index) => index === +restSplit[i]);
            if(has(element, 'CONDITION')) findTree = element?.CONDITION;
        }
        findTree?.push({
            COMPARE: "EMPTY",
            COMPARE_ACTION_IGNORECASE: "FALSE",
            LEVEL: templateHeader?.FILETYPE === "NVP" ? 'RECORD' : "FIELD",
            NAME: `UNNAMED${findTree?.length + 1}`,
            OPERATOR: "AND",
            RECORDTYPE: selectedNode?.title || "",
            VALUE: "",
            PATTERN:"MM/dd/yy"
        })
        let position, finalElement;
        const recordMappingRCTreeData = rmDataTransformer.toRCTree(copyPrevious,templateHeader?.FILETYPE);
        if(posSplit.length > 0){
            const lastIndex = findTree?.length;
            if(selectedRecordMapNode &&(
              selectedRecordMapNode.NAME === 'COMPOUND CONDITION' ||
              selectedRecordMapNode.NAME === 'COMPOUND_COMPOUND_MAPPING')){
                posSplit.push(lastIndex - 1);
                expandKey = selectedRecordMapNode?.key;
            }
            else{
                posSplit[posSplit.length - 1] = lastIndex - 1;
            }
            const pos = posSplit.join("-");
            position = pos;
            finalElement = findSelectedNodeFromRCTree(posSplit, recordMappingRCTreeData);
        }
        else{
            position = copyPrevious.length -1;
            finalElement = recordMappingRCTreeData[position];
            position = `rmp-${position}`;
          }
        setRecordMappingTreeData(copyPrevious)
        setSelectedKeys([`${position}`])
        setSelectedRecordMapNode(finalElement);
        setTranslatedData("CONDITION",copyPrevious);
        if(expandKey) setExpandedKeys(prev=>[...prev,expandKey]);
    }

    const addNewCompoundRecordMap = () => {
       setTestResult('');
        newCreationRef.current = true;
        let posSplit = (selectedRecordMapNode?.key || `rmp-0` )?.split("-") ;
        let copyPrevious = JSON.parse(JSON.stringify(recordMappingTreeData));

        const [_, ...restSplit] = posSplit;
        let findTree = copyPrevious;
        const count = restSplit.length;
        if(selectedRecordMapNode.TYPE === 'COMPOUND_RECORD_MAPPING'){
            for(let i = 0; i < count; i++){
                if(findTree[restSplit[i]].CONDITION)
                findTree = findTree[restSplit[i]].CONDITION
            }
        }
        else if(selectedRecordMapNode.TYPE === 'COMPOUND_COMPOUND_MAPPING'){
            for(let i = 0; i < count - 1; i++){
                if(findTree[restSplit[i]].CONDITION)
                findTree = findTree[restSplit[i]].CONDITION
            }
        }
        findTree?.splice(+restSplit[count-1] + 1, 0, {
            COMPARE_ACTION_IGNORECASE: "FALSE",
            NAME: "COMPOUND CONDITION",
            SUBSTRING: "",
            RECORDTYPE: selectedNode?.title || "",
            VALUE: "",
            CHILDOPERATOR: "AND",
            CONDITION: [
                {
                    COMPARE: "EMPTY",
                    COMPARE_ACTION_IGNORECASE: "FALSE",
                    LEVEL: templateHeader?.FILETYPE === "NVP" ? 'RECORD' : "FIELD",
                    NAME: `UNNAMED1`,
                    SUBSTRING: "",
                    VALUE: "",
                    // OPERATOR: "AND",
                    // RECORDTYPE: selectedNode?.title || "",
                    // MAPNAME: fields?.[0]?.MAPNAME?.toUpperCase() || undefined,
                    // FIELD_NAME: fields?.[0]?.MAPNAME?.toUpperCase() || undefined,
                    // FIELDNUM: fields?.length ? 1 : undefined 
                },
                {
                    COMPARE: "EMPTY",
                    COMPARE_ACTION_IGNORECASE: "FALSE",
                    LEVEL: templateHeader?.FILETYPE === "NVP" ? 'RECORD' : "FIELD",
                    NAME: `UNNAMED2`,
                    SUBSTRING: "",
                    VALUE: "",
                    // OPERATOR: "AND",
                    // RECORDTYPE: selectedNode?.title || "",
                    // MAPNAME: fields?.[0]?.MAPNAME?.toUpperCase() || undefined,
                    // FIELD_NAME: fields?.[0]?.MAPNAME?.toUpperCase() || undefined,
                    // FIELDNUM: fields?.length ? 1 : undefined 
                }
            ]
        })

        let position, finalElement;
        const recordMappingRCTreeData = rmDataTransformer.toRCTree(copyPrevious,templateHeader?.FILETYPE);
        if(posSplit.length > 0){
            posSplit[posSplit.length - 1] = !selectedRecordMapNode?.key ? 0  :+restSplit[count-1] + 1; 
            const pos = posSplit.join("-");
            position = `${pos}`;
            finalElement = 
            findSelectedNodeFromRCTree(posSplit, recordMappingRCTreeData);
        }
        setRecordMappingTreeData(copyPrevious);
        setSelectedKeys([position])
        setSelectedRecordMapNode(finalElement);
        setTranslatedData("CONDITION",copyPrevious);
        setExpandedKeys(prev=>[...prev || [], position])
    }

    const deleteRecordMap = () => {
        if(selectedRecordMapNode){
            let cloneTree = cloneDeep(recordMappingTreeData),
            findTree = cloneTree, 
            finalElement, 
            position;
            let posSplit = selectedRecordMapNode.key.split("-");
            
            if(['RECORD_MAPPING', 'COMPOUND_MAPPING'].includes(selectedRecordMapNode.TYPE)){
                const lastIndex = posSplit.length - 1;
                findTree.splice(posSplit[lastIndex], 1);
                position = `rmp-${findTree.length - 1}`;
                const recordMappingRCTreeData = rmDataTransformer.toRCTree(cloneTree,templateHeader?.FILETYPE);
                finalElement = recordMappingRCTreeData[recordMappingRCTreeData.length - 1];
            }
            else{
                const [_, ...indexes] =  posSplit;
                const count = indexes.length;
                for(let i = 0; i < count; i++){
                    if(i === count - 1){
                        findTree.splice(indexes[i], 1);
                    }
                    else{
                        findTree = findTree.find((_, index) => index === +indexes[i]);
                        if(findTree?.CONDITION){
                            if(i < count - 1) findTree = findTree.CONDITION;
                        }
                    }
                    
                }
                const lastIndex = posSplit.length - 1;
                const recordMappingRCTreeData = rmDataTransformer.toRCTree(cloneTree,templateHeader?.FILETYPE);
                if(findTree?.length > 0){
                    posSplit[lastIndex] = findTree?.length - 1;
                }
                else{
                    posSplit.splice(lastIndex, 1);
                }
                position = posSplit.join("-");
                finalElement = findSelectedNodeFromRCTree(posSplit, recordMappingRCTreeData);
            }
            setExpandedKeys(prev=>prev.filter(ele=>ele !== selectedRecordMapNode.key)) // Expand Key Should Be Removed
            setRecordMappingTreeData(cloneTree)
            setSelectedKeys([`${position}`])
            setSelectedRecordMapNode(finalElement);
            setTranslatedData("CONDITION",cloneTree);
        }
    }
    const onRightClickRecordMap = (info) => {
        if (selectedKeys[0] === info?.node?.key) return;
        setSelectedKeys([info.node.key]); // Fixed: To Hightlight on Right Click
        setSelectedRecordMapNode(info.node);
        if(info.node){
          stateValueHandler(info.node);
        }
    }


    const onSelectRecordMap =(_, data) => {
      if (selectedKeys[0] === data?.node?.key) return;
      if(!selectedKeys.filter(e=>e==data?.node?.key).length) setTestResult('');
        const finalElement = findSelectedNodeFromRCTree(data.node.key.split("-"), recordMappingRCTree)
        setSelectedRecordMapNode(finalElement);
        setSelectedKeys([data.node.key]);
        if(finalElement){
          stateValueHandler(finalElement);
        }
    }

    const setGenericChangeHandler = (event, Name, Value , stateFunction,valuesObj) => {
        if(!recordMappingRCTree?.length){
          // If there is not any data so no actions should execute. Fixed for Code Breaking.
          return;
        }
        let {name, value} = event?.target || {name: Name, value: Value};
        const splitKeys = selectedKeys?.[0]?.split('-');
        if(validateFields.includes(name)){
            const errorState = validateOnFlow(name, value, validationRules);
            const isEmptyObject = isEmpty(errorState);
            setErrors((prev) => {
                let copyPrev = JSON.parse(JSON.stringify(prev));
                if(isEmptyObject)
                    delete copyPrev[name];
                else {
                    copyPrev = {
                        ...copyPrev,
                        ...errorState
                    }
                }
                return copyPrev;
            })

            
            if(!isEmptyObject){
              // Reverting back wrong value;
              setTimeout(()=>{
                stateFunction((previousPrecisionValue) => {
                  let val = previousPrecisionValue;
                  val = val?.replaceAll(/\D/g, '');
                  if(val?.length > 9){
                    val = val.substring(0,9);
                  }
                  return val;
                })
              },validateRevertTime)

              // Removing error after some time by storing timerId in errorRef;
              if(errorRef.current[name]){
                clearTimeout(errorRef.current[name]);
              }
              
              const timerId= setTimeout(() => {
                setErrors((prev) => {
                  const copyPrev = JSON.parse(JSON.stringify(prev));
                  delete copyPrev[name];
                  return copyPrev;
                })
              }, validationTime)
              errorRef.current = {...errorRef.current , [name] : timerId}
              return;
            }
            
        }
        let copyPrevious = JSON.parse(JSON.stringify(recordMappingRCTree));
            const [_, ...restSplit] = splitKeys;
            let findTree = copyPrevious;
            const count = restSplit.length;
            for(let i= 0; i < count; i++){
                findTree = findTree?.find((_, index) => index === +restSplit[i]);
                if(findTree?.CONDITION && i < count - 1){
                    findTree = findTree.CONDITION;
                }
            }
            if(name) findTree[name] = value;
            else if(!isEmpty(valuesObj)) {
              for(let key in valuesObj){
                findTree[key] = valuesObj[key];
                if (valuesObj[key] === undefined && findTree?.hasOwnProperty(key)) delete findTree?.[key]; 
              }
            }
            if(name === "PORTIONING_TYPE"){
                findTree.LBL_TEST_DATA = '';
                findTree.readOnly = false;
                setTestResult('');
            }
            if(findTree?.PORTIONING_TYPE && 
                portioningType[findTree.PORTIONING_TYPE]?.includes(name)){
                    let fields = '';
                    for(let type in portioningType){
                        if(type !== findTree.PORTIONING_TYPE){
                            fields = portioningType[type];
                        }
                    }
                    const keys = transformSubstring(findTree, false);
                    for(let key in keys){
                        findTree[key] = keys[key]
                    }
                    for(let field of fields){
                        if(field === "LBL_FROM") 
                        findTree[field] = "LEFT";
                        else if(field === "LBL_PARSE_FROM")
                        findTree[field] = "LEFT";
                        else findTree[field] = '';
                    }
            }
            if(findTree?.LEVEL === "RECORD" && 
              !findTree?.PORTIONING_TYPE){
                findTree.PORTIONING_TYPE = "BTN_NONE";
            }
            // if(findTree?.NAME?.length === 0){
            //     findTree.NAME = 'UNNAMED';
            // }
            setRecordMappingTreeData(copyPrevious);
            setSelectedRecordMapNode(findTree);
            setTranslatedData("CONDITION", copyPrevious);
    }

    const setGenericBlurHandler = (event, Name, Value,stateFunction) => {
        if(!recordMappingRCTree?.length){
          // If there is not any data so no actions should execute.
          return;
        }
        const errorMessage = {
            LBL_START_POSITION: t('BOX_ENTER_NUM_FOR_START_POSITION'),
            LBL_NUM_OF_CHARS: t('BOX_ENTER_NUM_FOR_NO_CHAR'),
            LBL_START_OCCUR: t('BOX_ENTER_NUM_FOR_START_OCCUR'),
            LBL_END_OCCUR: t('BOX_ENTER_NUM_FOR_END_OCCUR')
        }
        // const {name, value} = event?.target || {name: Name, value: Value};
        // if(value.length === 0){
        //     setErrors((previous) => {
        //         return {
        //             ...previous,
        //             [name]: errorMessage[name] 
        //         }
        //     })
        // }
        const {name, value} = event?.target || {name: Name, value: Value};
        if(value.length === 0){
            const splitKeys = selectedKeys?.[0]?.split('-');
            let copyPrevious = JSON.parse(JSON.stringify(recordMappingRCTree));
            const [_, ...restSplit] = splitKeys;
            let findTree = copyPrevious;
            const count = restSplit.length;
            for(let i= 0; i < count; i++){
                findTree = findTree?.find((_, index) => index === restSplit[i]);
                if(findTree.CONDITION && i < count - 1){
                    findTree = findTree.CONDITION;
                }
            }
            findTree[name] = 0;
            if(name === "NAME") findTree[name] = "UNNAMED";
            else if (validateFields.includes(name)) {
              stateFunction(prev=>0);
            }
            setErrors((previous) => {
                let copyPrev = JSON.parse(JSON.stringify(previous));
                if(copyPrev.hasOwnProperty(name))
                    delete copyPrev[name];
                return copyPrev;
            });
            setRecordMappingTreeData(copyPrevious);
            setSelectedRecordMapNode(findTree);
            setTranslatedData("CONDITION", copyPrevious);
        }
    }

    const findSelectedNodeFromRCTree = (splitKeys, treeData) => {
        const [_,...indexes] = splitKeys;
        const count = indexes.length;
        let copyRCTree = JSON.parse(JSON.stringify(treeData || []));
        for(let i = 0; i < count; i++){
            copyRCTree = copyRCTree?.find((_, index) => index === +indexes[i])
            if(copyRCTree?.CONDITION && i < count - 1){
                copyRCTree = copyRCTree.CONDITION;
            }
        }
        return copyRCTree;
    }

    const testPortioningLogic = (type) => () => {
        let data = {};
        const selectedNode = selectedRecordMapNode;
        if(type === 'BTN_EXACT_PORTIONING'){
            data = {
                portioning_type: "Exact",
                start_position: +selectedNode?.LBL_START_POSITION,
                no_of_chars: +selectedNode?.LBL_NUM_OF_CHARS,
                parse: selectedNode?.LBL_FROM,
                test_data: selectedNode?.LBL_TEST_DATA
            }
        }
        else if(type === 'BTN_REL_PORTIONING'){
            data = {
                portioning_type: "Relative",
                start_value: selectedNode?.LBL_START_VAL,
                end_value: selectedNode?.LBL_END_VAL,
                start_occurrence: +selectedNode?.LBL_START_OCCUR,
                end_occurrence: +selectedNode?.LBL_END_OCCUR,
                parse: selectedNode?.LBL_PARSE_FROM,
                test_data: selectedNode?.LBL_TEST_DATA
            }
        }
        setPortioningResultLoading(true)
        dispatch(api.endpoints.testPortioningLogic.initiate({
            account,
            user,
            data
        }))
        .then(response => {
            if(response?.error){
              setTestResult(error || t('BOX_MSG_GENERAL_ERROR'))
            }
            if(response?.data?.current_state === "SUCCESS"){
                setTestResult(response.data.message);
            }
            else if(response?.data?.current_state === "ERROR"){
                setTestResult('')
            }
        })
        .catch((error) => {
          setTestResult(error || t('BOX_MSG_GENERAL_ERROR'))
        })
        .finally(() => setPortioningResultLoading(false))
    }

    const datePatternModalCancelHandler = () => {
        setDatePattern(selectedRecordMapNode?.PATTERN || '');
        setDpNetworkCallMessage('');
        setDatePatternModal(false);
      };
    
    const datePatternModalOkHandler = () => {
        setDpNetworkCallMessage('');
        setValid(true);
        if (flag) {
          setDatePatternModal(!datePatternModal);
          setGenericChangeHandler(null,"PATTERN",datePattern);
        } else {
          setDatePatternModal(!datePatternModal);
          setDatePattern(selectedRecordMapNode?.PATTERN || '')
        }
      };

    const testDateHandler = (key,val) => {
        if(!val){
          setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'))
          setValid(false)
        }
          if (val) {
            setValidateDatePatternLoading(true)
            dispatch(
              api.endpoints.validateDatePattern.initiate({
                datePattern: encodeURIComponent(val),
              })
            ).then((response) =>{
              if(response?.error){
                setValid(false);
                setDpNetworkCallMessage(error || error.message || t('BOX_MSG_GENERAL_ERROR'));
                return;
              }
              if(response?.data?.current_state === 'ERROR') {
                  setValid(false)
                  setFlag(false)
                  setDpNetworkCallMessage(response.data.message)
    
                } else {
                  if(key === 'fromField') debounceChangeHandler('PATTERN',val)
                   if(key === 'fromModal'){
                    setFlag(true)
                       setDpNetworkCallMessage(response.data.message)
                  }
                   setValid(true)
                 }
              }
            )
            .catch((error) => {
              setDpNetworkCallMessage(error || error.message || t('BOX_MSG_GENERAL_ERROR'))
            })
            .finally(() => {
              setValidateDatePatternLoading(false)
            })
          }
        
      };

    const docPath = `${baseUrl}/docs/${lgDocPath[lang] || 'en'}/Workbench/dialogs/DateFormatter.html`;
    const regExDocPath = `${baseUrl}/docs/${lgDocPath[lang] || 'en'}/Workbench/dialogs/regex.html`;
    
    const handleSegmentIdChange = (key, value) => {
      const newTranslatedData = eachDeep(cloneDeep(translatedData), (obj) => {
        if (!obj || !obj.key) {
          return;
        }
    
        if (obj.key === selectedNode.key) {
          if (!obj.FIELD) {
            obj.FIELD = {}; 
          }
    
          if (key === 'VALUE') {
            if (value === t('SELECT')) {
              delete obj.FIELD[key];
            } else {
              obj.FIELD[key] = value;
            }
          }
    
          dispatch(
            treeActions.setRightTreeSelectedNode({
              screen: parentScreen,
              type: rightTree.currentTab,
              data: obj,
            })
          );
        }
    
        if (isArray(obj?.children)) {
          return obj.children;
        }
      });
    
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: newTranslatedData,
        })
      );
    };

    const calculateRecordLength = () => {
      let length = 0;
      if (selectedNode && selectedNode?.children?.length !== 0) {
        selectedNode?.children.forEach((child) => {
          if (child?.ICON_DISPLAY === 'FIELD') {
            const childLength = isNaN(child.LENGTH) ? 0 : child.LENGTH;
            length = Number(child.BEGIN) + Number(childLength) - 1;
          }
        });
      }
      setRecordLength(length);
    }
    
    
   const handleRegExClose = () =>{
     setOpenRegExDialog(false);
   } 
   const debounceSegmentIdChange = useCallback(debounce(handleSegmentIdChange,800),[
    rightTree.currentTab,
    rightTree.tree,
   ])
    useEffect(() => {
        const len = recordMappingRCTree.length;
        if(len > 0 && !isMounted){
                setIsMounted(true);
                setSelectedRecordMapNode(recordMappingRCTree[0]);
                if(recordMappingRCTree[0]){
                  stateValueHandler(recordMappingRCTree[0])
                }
        }

        if(!len){
          // Fixed : Not showing previous data in fields.
          setSelectedRecordMapNode('');
        }

    },[recordMappingRCTree, isMounted, fields]);

    useEffect(() => {
      setIsMounted(false);
      calculateRecordLength();
    },[selectedNode?.key,rightTree.currentTab])

    useEffect(()=>{     
      if(newCreationRef.current){
        scrollToSelectedItem(selectedKeys,mappingRef)
      }
      newCreationRef.current = false;
    },[selectedKeys])

    useEffect(() => {
       // setTestResult('');
        if(selectedRecordMapNode){
          setDatePattern(selectedRecordMapNode?.PATTERN || '');
        }
        if(!isEmpty(selectedRecordMapNode)) stateValueHandler(selectedRecordMapNode,true);
    },[selectedRecordMapNode])

    // Update dialog value when selected record map node changes
    useEffect(() => {
        if(selectedRecordMapNode?.["VALUE"] !== undefined) {
            const processedValue = delimDisplay(selectedRecordMapNode?.["VALUE"] || "", true);
            setDelimDialogValue(processedValue);
        }else {
          setDelimDialogValue('');
        }
    }, [selectedRecordMapNode?.["VALUE"]])

    const stateValueHandler =(obj,focusComparator)=>{
      setStartPosition(obj?.LBL_START_POSITION || 0);
      setNumberChar(obj?.LBL_NUM_OF_CHARS || 0);
      setStartVal(obj?.LBL_START_OCCUR || 0);
      setEndVal(obj?.LBL_END_OCCUR || 0);
      if (obj?.LEVEL === "FIELD") setComparatorField(obj,focusComparator)
      setErrors({});
      // patternValidator(obj);
    }

    // const patternValidator =(obj)=>{
    //   if(['RECORD_MAPPING','COMPOUND_RECORD_MAPPING'].includes(obj?.TYPE) &&  obj.COMPARE !== 'IS_DATE'){
    //     // debounceChangeHandler('PATTERN','MM/dd/yy');
    //     setPattern('MM/dd/yy');
    //   }
    // }


    const onExpandKeys =(keys,info)=>{
      if(!info.expanded && selectedKeys?.[0]?.includes(info.node.key)){
        setExpandedKeys(expandedKeys.filter(ele => ele !== info.node.key));
        setSelectedRecordMapNode(info.node);
        setSelectedKeys([info.node.key]);
      }else{
        setExpandedKeys(keys);
      }
    }

    const getNextValidNode =(data = [])=>{
      let nodeKey = '';
      const iterateData = (dataArray = [])=>{
        if(nodeKey) return nodeKey
        dataArray.forEach(ele=>{
          if(!ele.ICON_DISPLAY.includes('FIELD_GROUP')) {
            if(!nodeKey) nodeKey = ele;
            return nodeKey;
          }
          if(ele?.children?.length) iterateData(ele?.children)
        })
      }
      iterateData(data);
      return nodeKey;
    }

    const getExpandedKeys= (key) =>{
      if(!key) return [];
      const keys = [];
      let newKey  = '';
      key.split('-').forEach((ele,idx)=>{
        if(idx > 0){
          newKey+= `-${ele}`;
          keys.push(newKey);
        }else {
          newKey = ele;
        }
      })
      return keys;
    }

    const setComparatorField =(obj,focusComparator)=>{
      const mapname = obj?.FIELD_NAME;
      const level  = `${obj?.FIELD_OUTLINE_LEVEL || ''}`;

      let key;
      let expandedKeys = [];
      let matched =false;
      if(level && mapname){
        const tempLevel = level?.includes('.') ? level?.split('.') : [level];
        let parent = fields;
        for(let i=0;i < tempLevel?.length ;i++){
          parent = parent?.[tempLevel[i] - 1]?.children || [];
        }
        parent?.forEach(ele=>{
          if(ele?.MAPNAME?.toLowerCase() === mapname?.toLowerCase()){
            matched = true;
            key = ele?.key;
            expandedKeys = getExpandedKeys(key);
          }
        })
        
      }else if (!level && mapname){
        fields.forEach(ele=>{
          if(ele?.MAPNAME?.toLowerCase() === mapname?.toLowerCase()){
            matched = true;
            key = ele?.key;
            expandedKeys = getExpandedKeys(key);
          }
        })
      }

      // If no condition matched;
      if(!matched){
        key = getNextValidNode(fields);
        if (fields?.length > 0 && key) fieldSelectHandler([], {node: key})
        expandedKeys = getExpandedKeys(key?.key);
      }
      if(!selectedByClick && focusComparator) scrollToSelectedItem([typeof key === 'string' ? key : key?.key],comparatorRef);
      setFieldSelectedkeys([typeof key === 'string' ? key : key?.key]);
      setFieldExpandedKeys(prev=>[...prev,expandedKeys]);
      setSelectedByClick(false);
    }

    const fieldSelectHandler =(keys,info)=>{
      if (!info?.node) return;
      setSelectedByClick(true);
      const key = info?.node?.key?.split('-');

      if(info?.node?.ICON_DISPLAY?.includes('FIELD_GROUP')){
        setError(t('BOX_PLEASE_SELECT_A_FIELD_NOT_FG'));
        setErrorModal(true);
        return;
      }

      if(key.length === 2){
        setGenericChangeHandler(null,null,null,null,{
          FIELD_NAME:info?.node?.MAPNAME?.toUpperCase(),
          FIELD_OUTLINE_LEVEL: undefined,
          MAPNAME:info?.node?.MAPNAME?.toUpperCase(),
          FIELDNUM: info?.node?.FIELDNUM
        });
      }else{
        let level = key.splice(1)
        level?.splice(level.length - 1)
        level = level?.map(ele=> +ele + 1)?.join('.');
        setGenericChangeHandler(null,null,null,null,{
          FIELD_NAME:info?.node?.MAPNAME?.toUpperCase(),
          MAPNAME:info?.node?.MAPNAME?.toUpperCase(),
          FIELD_OUTLINE_LEVEL: ["DELIM_FLD_ID", "MULIT_DELIMITED", "EDI", "HL7"].includes(templateHeader.FILETYPE) ? level : undefined,
          FIELDNUM: info?.node?.FIELDNUM
        });
      }
      setFieldSelectedkeys([info.node.key]);
    }
    const setRegularExpressionValue = (value) => {
      setGenericChangeHandler(null, "VALUE", value);
    };
    
    return (
      <>
        <Stack spacing={"15px"} className="tp-segment">
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_REC_NAME")}
              type="text"
              className={"width-100"}
              name={"TITLE"}
              value={recordName}
              onChange={recordNameChange}
              {...(has(errors, "TITLE")
                ? {
                    helperText: errors["TITLE"],
                    error: true,
                  }
                : {
                    helperText: "",
                    error: false,
                  })}
              onBlur={onRecordBlur}
              //onBlur={onValidate}
            />
          </FormControl>
          {templateHeader.FILETYPE === 'FIXED_LENGTH' && <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_RECORD_LENGTH")}
              type="text"
              className={"width-100"}
              name={"LBL_RECORD_LENGTH"}
              value={recordLength}
              disabled={true}
            />
          </FormControl>}
          {templateHeader.FILETYPE === "HL7" && (
            <FormControl className="width-100" size="small" variant="outlined">
              <Autocomplete
                freeSolo
                size="small"
                options={segmentOptions}
                value={hl7SegmentId || ''}
                onChange={(e,newValue) => {
                  setHL7SegmentId(newValue);
                  debounceSegmentIdChange("VALUE", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("LBL_HL7_SEGMENT_ID")}
                    value={hl7SegmentId || ''}
                    onChange={(e) => {
                      setHL7SegmentId(e.target.value);
                      debounceSegmentIdChange("VALUE", e.target.value);
                    }}
                 />
                )}
              />
            </FormControl>
          )}
          {/* <ForwardSlashError showError={showError} /> */}
          {templateHeader?.FILETYPE === "EDI" && <EDIRecordProperty/>}
          {["HL7", "DELIMITED", "MULIT_DELIMITED","NVP","SERVLET", 'DELIM_FLD_ID'].includes(
            templateHeader.FILETYPE
          ) && (
            <>
              <FormControl className="width-100" size="small">
              <ItemPropertiesDelimiterInput
                  default
                  label={t("LBL_FLD_DELIM_OVERRIDE_OPTIONAL")}
                  name={"DELIMITER"}
                />
              </FormControl>
            </>
          )}
          {templateHeader.FILETYPE === "DELIM_FLD_ID" &&
            rightTree.currentTab === "header" && (
              <FormControl className="width-100" size="small">
                <TPCheckbox
                  name="FIXED_LENGTH_RECORD"
                  label={t("BTN_FIXED_LENGTH_RECORD")}
                  checked={fixedLengthRecord}
                  handleCheck={(checked) => {
                    setFixedLengthRecord(checked);
                    debounceNameChangeHandler(
                      "FIXED_LENGTH",
                      checked === true ? "TRUE" : "FALSE"
                    );
                  }}
                />
              </FormControl>
            )}
          <div className="divider-top"></div>
          <FormControl  id="recordMapping" className="width-100" size="small">
            <FormLabel>{t("LBL_RECORD_MAPPING_CONDITIONS")}</FormLabel>
            <div ref={mappingRef} className="div-textbox">
              <Tree
                titleRender={titleRender}
                defaultExpandAll={true}
                autoExpandParent
                focusable
                className="myCls"
                showLine
                autoFocus
                treeData={recordMappingRCTree}
                selectedKeys={selectedKeys}
                expandedKeys={expandedKeys}
                icon={Icon}
                onRightClick={onRightClickRecordMap}
                onExpand={onExpandKeys}
                onSelect={onSelectRecordMap}
                switcherIcon={switcherIcon}
                selectable
              />
            </div>
            <RecordMappingContextMenu
              onCreateRecordMap={addNewRecordMap}
              onCreateCompoundRecordMap={addNewCompoundRecordMap}
              onDeleteRecordMap={deleteRecordMap}
              hasRecordMappings={recordMappingRCTree?.length > 0}
              hasSelectedMapping={selectedKeys?.length > 0 && !isEmpty(selectedRecordMapNode)}
            />
          </FormControl>
          <FormControl className="width-100" size="small">
            <TextField
              disabled={isEmpty(selectedRecordMapNode)}
              variant="outlined"
              size="small"
              label={t("LBL_CONDITION_NAME")}
              type="text"
              className={"width-100"}
              name={"NAME"}
              value={selectedRecordMapNode?.NAME || ""}
              onChange={setGenericChangeHandler}
              onBlur={setGenericBlurHandler}
            />
          </FormControl>
          {selectedRecordMapNode?.ICON_DISPLAY === "NETWORK_FOLDER" ||
          selectedRecordMapNode?.TYPE === "COMPOUND_COMPOUND_MAPPING" ? (
            <>
              <Typography variant="body2">
                {t("LBL_SEL_OPER_FOR_COND_CONTAINED_WITHIN_COMP_COND")}
              </Typography>
              <FormControl
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                ml={3}>
                <FormLabel>{t("LBL_COMPOUND_OPER")}</FormLabel>
                <RadioGroup
                  row
                  name="CHILDOPERATOR"
                  value={selectedRecordMapNode?.CHILDOPERATOR}
                  onChange={(event) => setGenericChangeHandler(event)}>
                  <FormControlLabel
                    value={"OR"}
                    control={<Radio />}
                    label={"OR"}
                  />
                  <FormControlLabel
                    value={"AND"}
                    control={<Radio />}
                    label={"AND"}
                  />
                </RadioGroup>
              </FormControl>
            </>
          ) : (
            <FormControl variant="outlined" className="width-100" size="small">
              <InputLabel 
                sx={isEmpty(selectedRecordMapNode) ? StylingObject.disabledSelectLabel : {}} 
                id="flDropdownLabel"
              >
                {t("LBL_COMPARATOR_SCOPE")}
              </InputLabel>
              <Select
                disabled={isEmpty(selectedRecordMapNode)}
                className={"width-100"}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300,
                    },
                  },
                }}
                name={"LEVEL"}
                labelId="flDropdownLabel"
                label={t("LBL_FLD_TYPE")}
                id="flDropdown"
                value={selectedRecordMapNode?.LEVEL || "RECORD"}
                onChange={setGenericChangeHandler}>
                {(templateHeader.FILETYPE==="NVP"? scopesDropdownNVP : scopesDropdown)?.map((obj, key) => (
                  <MenuItem key={key} value={obj.value}>
                    {obj.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* {fieldLevel === t('FIELD') && */}
          {selectedRecordMapNode?.TYPE !== "NETWORK_FOLDER" &&
            selectedRecordMapNode?.TYPE !== "COMPOUND_COMPOUND_MAPPING" &&
            selectedRecordMapNode?.LEVEL === "FIELD" && (
              <FormControl className="width-100" size="small">
                {/* <div className='flex space-between'> */}
                <FormLabel>{t("LBL_COMPARATOR_FLD")}</FormLabel>
                <div ref={comparatorRef} className="div-textbox">
                  <Tree
                    titleRender={titleRender}
                    selectedKeys={fieldSelectedKeys}
                    expandedKeys={fieldExpandedKeys}
                    onSelect={(keys,info)=>fieldSelectHandler(keys,info)}
                    onExpand={(keys)=>setFieldExpandedKeys(keys)}
                    focusable={true}
                    className="myCls"
                    showLine
                    autoFocus
                    selectable
                    treeData={fields}
                    switcherIcon={switcherIcon}
                    icon={Icon}
                  />
                </div>
                {/* </div> */}
              </FormControl>
            )}
          {/* {fieldLevel === t('RECORD') &&  */}
          {selectedRecordMapNode?.ICON_DISPLAY !== "NETWORK_FOLDER" &&
            selectedRecordMapNode?.TYPE !== "COMPOUND_COMPOUND_MAPPING" &&
            selectedRecordMapNode?.LEVEL === "RECORD" && (
              <FormControl>
                <FormLabel>
                  {t("LBL_SPECIFY_PORTION_TO_USE_FOR_MAPPING")}
                </FormLabel>
                <RadioGroup
                  row
                  name={"PORTIONING_TYPE"}
                  value={selectedRecordMapNode.PORTIONING_TYPE}
                  onChange={(event) => setGenericChangeHandler(event)}>
                  <FormControlLabel
                    value={"BTN_EXACT_PORTIONING"}
                    control={<Radio />}
                    label={t("BTN_EXACT_PORTIONING")}
                  />
                  <FormControlLabel
                    value={"BTN_REL_PORTIONING"}
                    control={<Radio />}
                    label={t("BTN_REL_PORTIONING")}
                  />
                  <FormControlLabel
                    value={"BTN_NONE"}
                    control={<Radio />}
                    label={t("BTN_NONE")}
                  />
                </RadioGroup>
                {selectedRecordMapNode.PORTIONING_TYPE ===
                  "BTN_EXACT_PORTIONING" && (
                  <Stack spacing={"10px"} className="tp-segment">
                    <FormControl className="width-100" size="small">
                      <CustomTextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_START_POSITION")}
                        type="text"
                        className={"uppercase-input width-100"}
                        name={"LBL_START_POSITION"}
                        onChange={(e)=>{
                          const {value} = e.target;
                          setStartPosition(value);
                          setGenericChangeHandler(e,'','',setStartPosition)
                        }}
                        onBlur={(e)=>{
                          setGenericBlurHandler(e,'','',setStartPosition)
                        }}
                        // InputLabelProps={{shrink: true}}
                        value={startPosition}
                        helperText={
                          (has(errors, "LBL_START_POSITION") &&
                            errors["LBL_START_POSITION"]) ||
                          ""
                        }
                        error={has(errors, "LBL_START_POSITION")}
                      />
                      {/* <TextField
                                variant='outlined'
                                size="small"
                                label={t('LBL_START_POSITION')}
                                type="text"
                                className={"uppercase-input width-100"}
                                name={'LBL_START_POSITION'}
                                onChange={setGenericChangeHandler}
                                onBlur={setGenericBlurHandler}
                                // InputLabelProps={{shrink: true}}
                                value={selectedRecordMapNode?.['LBL_START_POSITION']}
                                helperText={has(errors, 'LBL_START_POSITION') && errors['LBL_START_POSITION'] || ""}
                                error={has(errors, 'LBL_START_POSITION')}
                            /> */}
                    </FormControl>
                    <FormControl className="width-100" size="small">
                      <CustomTextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_NUM_OF_CHARS")}
                        type="text"
                        className={"uppercase-input width-100"}
                        name={"LBL_NUM_OF_CHARS"}
                        onChange={(e)=>{
                          const {value} = e.target;
                          setNumberChar(value);
                          setGenericChangeHandler(e,'','',setNumberChar)
                        }}
                        onBlur={(e)=>{
                          setGenericBlurHandler(e,'','',setNumberChar)
                        }}
                        // InputLabelProps={{shrink: true}}
                        value={numberChar}
                        helperText={
                          (has(errors, "LBL_NUM_OF_CHARS") &&
                            errors["LBL_NUM_OF_CHARS"]) ||
                          ""
                        }
                        error={has(errors, "LBL_NUM_OF_CHARS")}
                      />
                    </FormControl>
                    <FormControl
                      variant="outlined"
                      className="width-100"
                      size="small">
                      <InputLabel id="fromExactDropdown">
                        {t("LBL_FROM")}
                      </InputLabel>
                      <Select
                        disabled={isEmpty(selectedRecordMapNode)}
                        className={"width-100"}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 300,
                            },
                          },
                        }}
                        // name={"FROMEXACT"}
                        // value={leftRight}
                        name="LBL_FROM"
                        value={
                          selectedRecordMapNode?.["LBL_FROM"] ||
                          fromExactDropdowns[0]?.value
                        }
                        labelId="fromExactDropdown"
                        label={t("LBL_FROM")}
                        id="fromExactDropdown"
                        onChange={setGenericChangeHandler}>
                        {fromsExact}
                      </Select>
                    </FormControl>
                    <Typography variant="body2">
                      {t("LBL_TEST_YOUR_PORTION_LOGIC_HERE")}
                    </Typography>
                    <FormControl className="width-100" size="small">
                      <div className="flex">
                        <TextField
                          variant="outlined"
                          size="small"
                          label={t("LBL_TEST_DATA")}
                          type="text"
                          className={"width-100"}
                          name={"LBL_TEST_DATA"}
                          value={selectedRecordMapNode?.["LBL_TEST_DATA"]}
                          onChange={setGenericChangeHandler}
                        />
                        <Button
                          variant="outlined"
                          size="small"
                          disableElevation
                          className="margin-left-4"
                          sx={{
                            width: "80px",
                            padding: "4px 8px",
                            minWidth: "40px",
                          }}
                          disabled={portioningResultLoading}
                          onClick={testPortioningLogic("BTN_EXACT_PORTIONING")}>
                          {portioningResultLoading ? <CircularProgress size={"20px"} /> : t("BTN_TEST_IT")}
                        </Button>
                      </div>
                    </FormControl>
                    <FormControl className="width-100" size="small">
                      <TextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_TEST_RESULT")}
                        type="text"
                        className={"width-100"}
                        name={t("LBL_TEST_RESULT")}
                        value={testResult}
                      />
                    </FormControl>
                  </Stack>
                )}
                {selectedRecordMapNode.PORTIONING_TYPE ===
                  "BTN_REL_PORTIONING" && (
                  <Stack spacing={"10px"} className="tp-segment">
                    <FormControl className="width-100" size="small">
                      <TextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_START_VAL")}
                        type="text"
                        className={"width-100"}
                        name={"LBL_START_VAL"}
                        value={selectedRecordMapNode["LBL_START_VAL"]}
                        onChange={setGenericChangeHandler}
                      />
                    </FormControl>
                    <FormControl className="width-100" size="small">
                      <TextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_END_VAL")}
                        type="text"
                        className={"width-100"}
                        name={"LBL_END_VAL"}
                        value={selectedRecordMapNode["LBL_END_VAL"]}
                        onChange={setGenericChangeHandler}
                      />
                    </FormControl>
                    <FormControl className="width-100" size="small">
                      <CustomTextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_START_OCCUR")}
                        type="text"
                        className={"uppercase-input width-100"}
                        name={"LBL_START_OCCUR"}
                        value={startVal}
                        // InputLabelProps={{shrink: true}}
                        onChange={(e)=>{
                          const {value} = e.target;
                          setStartVal(value);
                          setGenericChangeHandler(e,'','',setStartVal)
                        }}
                        onBlur={(e)=>{
                          setGenericBlurHandler(e,'','',setStartVal)
                        }}
                        helperText={
                          (has(errors, "LBL_START_OCCUR") &&
                            errors["LBL_START_OCCUR"]) ||
                          ""
                        }
                        error={has(errors, "LBL_START_OCCUR")}
                      />
                    </FormControl>
                    <FormControl className="width-100" size="small">
                      <CustomTextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_END_OCCUR")}
                        type="text"
                        className={"uppercase-input width-100"}
                        name={"LBL_END_OCCUR"}
                        value={endVal}
                        // InputLabelProps={{shrink: true}}
                        onChange={(e)=>{
                          const {value} = e.target;
                          setEndVal(value);
                          setGenericChangeHandler(e,'','',setEndVal)
                        }}
                        onBlur={(e)=>{
                          setGenericBlurHandler(e,'','',setEndVal)
                        }}
                        helperText={
                          (has(errors, "LBL_END_OCCUR") &&
                            errors["LBL_END_OCCUR"]) ||
                          ""
                        }
                        error={has(errors, "LBL_END_OCCUR")}
                      />
                    </FormControl>
                    <FormControl
                      variant="outlined"
                      className="width-100"
                      size="small">
                      <InputLabel id="fromDropdown">{t("LBL_FROM")}</InputLabel>
                      <Select
                        className={"width-100"}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 300,
                            },
                          },
                        }}
                        name={"LBL_PARSE_FROM"}
                        value={
                          selectedRecordMapNode?.["LBL_PARSE_FROM"] ||
                          fromRelativeDropdowns[0]?.value
                        }
                        labelId="fromDropdown"
                        label={t("LBL_FROM")}
                        id="fromDropdown"
                        onChange={setGenericChangeHandler}>
                        {fromsRelative}
                      </Select>
                    </FormControl>
                    <Typography variant="body2">
                      {t("LBL_TEST_YOUR_PORTION_LOGIC_HERE")}
                    </Typography>
                    <FormControl className="width-100" size="small">
                      <div className="flex">
                        <TextField
                          variant="outlined"
                          size="small"
                          label={t("LBL_TEST_DATA")}
                          type="text"
                          className={"width-100"}
                          name={"LBL_TEST_DATA"}
                          value={selectedRecordMapNode["LBL_TEST_DATA"]}
                          onChange={setGenericChangeHandler}
                        />
                        <Button
                          variant="outlined"
                          size="small"
                          disableElevation
                          className="margin-left-4"
                          sx={{
                            width: "80px",
                            padding: "4px 8px",
                            minWidth: "40px",
                          }}
                          disabled={portioningResultLoading}
                          onClick={testPortioningLogic("BTN_REL_PORTIONING")}>
                          { portioningResultLoading ? <CircularProgress size={'20px'} />: t("BTN_TEST_IT") }
                        </Button>
                      </div>
                    </FormControl>
                    <FormControl className="width-100" size="small">
                      <TextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_TEST_RESULT")}
                        type="text"
                        className={"width-100"}
                        name={"LBL_TEST_RESULT"}
                        value={testResult}
                        // value={selectedRecordMapNode['LBL_TEST_RESULT']}
                        // onChange={setGenericChangeHandler}
                      />
                    </FormControl>
                  </Stack>
                )}
              </FormControl>
            )}
          {selectedRecordMapNode?.TYPE?.includes("RECORD") && (
            <>
              <div className="divider-top"></div>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between">
                <TPCheckbox
                  disabled={isEmpty(selectedRecordMapNode)}
                  name="COMPARE_ACTION_NOT"
                  checked={
                    selectedRecordMapNode?.["COMPARE_ACTION_NOT"] === "TRUE"
                  }
                  label={t("BTN_NOT")}
                  // checked={not}
                  handleCheck={(checked) => {
                    setGenericChangeHandler(
                      null,
                      "COMPARE_ACTION_NOT",
                      checked ? "TRUE" : "FALSE"
                    );
                  }}
                  // handleCheck={(checked) => {
                  //     setNot(checked);
                  // }}
                />
                <FormControl
                  variant="outlined"
                  className="width-100"
                  size="small">
                  <InputLabel
                    sx={
                      isEmpty(selectedRecordMapNode)
                        ? StylingObject.disabledSelectLabel
                        : {}
                    }
                    id="operatorDropdown">
                    {t("LBL_OPERATOR")}
                  </InputLabel>
                  <Select
                    disabled={isEmpty(selectedRecordMapNode)}
                    className={"width-100"}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 300,
                        },
                      },
                    }}
                    name={"COMPARE"}
                    value={selectedRecordMapNode?.["COMPARE"] || ""}
                    labelId="operatorDropdown"
                    label={t("LBL_OPERATOR")}
                    id="operatorDropdown"
                    onChange={setGenericChangeHandler}>
                    {operators}
                    {templateHeader.FILETYPE === "HL7" && (
                      <MenuItem value="IS_HL7_NULL">
                        {t("IS_HL7_NULL")}
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>
              <Box
                display="flex"
                alignItems="center">
                {!["EMPTY", "IS_NUMERIC", "IS_DATE"]?.includes(
                  selectedRecordMapNode?.["COMPARE"]
                ) && (
                  <TPCheckbox
                    disabled={isEmpty(selectedRecordMapNode)}
                    name={"COMPARE_ACTION_IGNORECASE"}
                    label={t("IGNORECASE")}
                    checked={
                      selectedRecordMapNode?.["COMPARE_ACTION_IGNORECASE"] ==
                      "TRUE"
                    }
                    handleCheck={(checked) => {
                      setGenericChangeHandler(
                        null,
                        "COMPARE_ACTION_IGNORECASE",
                        checked ? "TRUE" : "FALSE"
                      );
                    }}
                    // handleCheck={(checked) => {
                    //     setIgnoreCase(checked);
                    // }}
                  />
                )}
                <TPCheckbox
                  disabled={isEmpty(selectedRecordMapNode)}
                  name={"COMPARE_ACTION_TRIM"}
                  label={t("BTN_TRIM_DATA")}
                  checked={
                    selectedRecordMapNode?.["COMPARE_ACTION_TRIM"] === "TRUE"
                  }
                  handleCheck={(checked) => {
                    setGenericChangeHandler(
                      null,
                      "COMPARE_ACTION_TRIM",
                      checked ? "TRUE" : "FALSE"
                    );
                  }}
                  // handleCheck={(checked) => {
                  //     setTrimData(checked);
                  // }}
                />
              </Box>
              {selectedRecordMapNode?.ICON_DISPLAY !== "NETWORK_FOLDER" &&
                selectedRecordMapNode?.["COMPARE"] === "IS_DATE" && (
                  <FormControl className="width-100" size="small">
                    <div className="flex">
                      <TextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_PATTERN")}
                        className={"width-100"}
                        name="PATTERN"
                        value={selectedRecordMapNode?.PATTERN || ""}
                        error={!valid}
                        onChange={(e) => {
                          setGenericChangeHandler(e);
                          setDpNetworkCallMessage("");
                          setFlag(false);
                          setValid(true);
                        }}
                      />
                      <Button
                        variant="outlined"
                        size="small"
                        disableElevation
                        className="margin-left-4"
                        sx={{
                          width: "40px",
                          padding: "4px 8px",
                          minWidth: "40px",
                        }}
                        onClick={() => setDatePatternModal(true)}>
                        <CalendarMonthOutlinedIcon fontSize="small" />
                      </Button>
                    </div>
                    {/* <div style={{display:'inline-block'}}>
                                <p style={{fontSize:'12px',margin:'10px'}}>{dpNetworkCallMessage}</p>
                                </div> */}
                    </FormControl>
                  )}
                <div className="divider-top"></div>
              </>
            )}
          {selectedRecordMapNode?.ICON_DISPLAY !== "NETWORK_FOLDER" &&
            selectedRecordMapNode?.TYPE !== "COMPOUND_COMPOUND_MAPPING" &&
            !["EMPTY", "IS_NUMERIC", "IS_DATE"]?.includes(
              selectedRecordMapNode?.["COMPARE"]
            ) && (
              <>
                <FormControl className="width-100" size="small">
                  <div className="flex">
                    <TextField
                      disabled={isEmpty(selectedRecordMapNode)}
                      variant="outlined"
                      size="small"
                      label={t("LBL_VAL_TO_COMPARE")}
                      type="text"
                      className={"width-100"}
                      name={"VALUE"}
                      value={(
                        delimDisplay(selectedRecordMapNode?.["VALUE"] || "")
                      )}
                      onChange={setGenericChangeHandler}
                    />
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={
                        !valueToCompareVisibleItems.includes(
                          selectedRecordMapNode?.["COMPARE"]
                        )
                      }
                      disableElevation
                      className="margin-left-4"
                      sx={{
                        width: "40px",
                        padding: "4px 8px",
                        minWidth: "40px",
                      }}
                      onClick={
                        selectedRecordMapNode?.["COMPARE"] ==
                        "REGULAR_EXPRESSION"
                          ? handleRegExModal
                          : handleModal
                      }>
                      <MoreHorizIcon fontSize="small" />
                    </Button>
                  </div>
                </FormControl>
                {openRegExDialog && (
                  <RegularExpressionDialog
                    openRegExDialog={openRegExDialog}
                    regExDocPath={regExDocPath}
                    handleRegExClose={() => setOpenRegExDialog(false)}
                    regExValue={(
                      selectedRecordMapNode?.["VALUE"] || ""
                    )}
                    setValue={
                      setRegularExpressionValue
                    }></RegularExpressionDialog>
                )}

                <DelimiterDialog
                  modalOpen={modalOpen}
                  close={toggle}
                  val={delimDialogValue}
                  handleInput={(value) =>
                    setGenericChangeHandler(null, "VALUE", value)
                  }
                  from="recordPropertyForm"
                />
              </>
            )}
        </Stack>
        <DatePattern
          openModal={datePatternModal}
          docPath={docPath}
          okHandler={datePatternModalOkHandler}
          cancelHandler={datePatternModalCancelHandler}
          onChangeHandler={setDatePattern}
          // onChangeHandler={(value) => setGenericChangeHandler(null, 'PATTERN', value)}
          testDateHandler={testDateHandler}
          dpNetworkCallMessage={dpNetworkCallMessage}
          datePattern={datePattern}
          loading={validateDatePatternLoading}
          // datePattern={selectedRecordMapNode?.["PATTERN"]}
          valid={valid}
        />
        <ErrorModal
          errorModal={errorModal}
          errorMessage={error}
          handleErrorModal={setErrorModal}
        />
        {/* {alertDialog.open && 
            <AlertDialog 
                open={alertDialog.open}
                message={alertDialog.message}
                onClose={onCloseAlert}/>} */}
      </>
    ); 
}

export default RecordPropertyForm

const transformSubstring = (value, readOnly = true) => {
    if(value?.SUBSTRING && readOnly){
        const splitVal = value.SUBSTRING.split("%1F");
        const splitValLen = splitVal.length;
        if(splitValLen === 3){
            const [LBL_FROM= "LEFT", LBL_START_POSITION = "", LBL_NUM_OF_CHARS = ""] = splitVal;
            return {
                LBL_FROM,
                LBL_START_POSITION,
                LBL_NUM_OF_CHARS,
                PORTIONING_TYPE: 'BTN_EXACT_PORTIONING'
            }
        }
        else if(splitValLen === 5){
            let [LBL_PARSE_FROM= "LEFT", 
              LBL_START_OCCUR = "",
                LBL_START_VAL = "",
                LBL_END_OCCUR = "",
                LBL_END_VAL = "",
              ] = splitVal;
            if(LBL_PARSE_FROM === 'PARSELEFT') LBL_PARSE_FROM = 'LEFT';
            if(LBL_PARSE_FROM === 'PARSERIGHT') LBL_PARSE_FROM = 'RIGHT';
            return {
                LBL_PARSE_FROM,
                LBL_START_VAL,
                LBL_END_VAL,
                LBL_START_OCCUR,
                LBL_END_OCCUR,
                PORTIONING_TYPE: 'BTN_REL_PORTIONING' 
            }
        }
    }
    else if(value?.PORTIONING_TYPE === 'BTN_EXACT_PORTIONING'){
        const {
            LBL_FROM= "LEFT", 
            LBL_START_POSITION = "", 
            LBL_NUM_OF_CHARS = "",
            LBL_PARSE_FROM = "LEFT",
            LBL_START_VAL = "", 
            LBL_END_VAL = "",
            LBL_START_OCCUR = "0",
            LBL_END_OCCUR = "0"
            } = value;
        const enableSubStr = true;
        return {
            SUBSTRING: enableSubStr ?
            [LBL_FROM, 
             LBL_START_POSITION, 
             LBL_NUM_OF_CHARS].join('%1F') : "",
            LBL_FROM,
            LBL_START_POSITION,
            LBL_NUM_OF_CHARS,
            PORTIONING_TYPE: 'BTN_EXACT_PORTIONING',
            readOnly,
            LBL_PARSE_FROM,
            LBL_START_VAL, 
            LBL_END_VAL,
            LBL_START_OCCUR,
            LBL_END_OCCUR
        }
    }
    else if(value?.PORTIONING_TYPE === 'BTN_REL_PORTIONING'){
        const parseFromMapping = {
          "LEFT" : "PARSELEFT",
          "RIGHT": "PARSERIGHT",
          "PARSERIGHT":"PARSERIGHT",
          "PARSELEFT": "PARSELEFT"
        }
        const {
            LBL_FROM= "LEFT", 
            LBL_START_POSITION = "", 
            LBL_NUM_OF_CHARS = "",
            LBL_PARSE_FROM = "LEFT", 
            LBL_START_VAL = "", 
            LBL_END_VAL = "",
            LBL_START_OCCUR = "",
            LBL_END_OCCUR = ""} = value;
        const enableSubStr = true;
        return {
            SUBSTRING: enableSubStr ? [
              parseFromMapping[LBL_PARSE_FROM],
                LBL_START_OCCUR,
                LBL_START_VAL,
                LBL_END_OCCUR,
                LBL_END_VAL].join("%1F") : "",
            LBL_PARSE_FROM,
            LBL_START_VAL,
            LBL_END_VAL,
            LBL_START_OCCUR,
            LBL_END_OCCUR,
            PORTIONING_TYPE: 'BTN_REL_PORTIONING',
            readOnly,
            LBL_FROM, 
            LBL_START_POSITION, 
            LBL_NUM_OF_CHARS 
        }
    }
    else if(value?.PORTIONING_TYPE === 'BTN_NONE'){
      const {
          LBL_FROM= "LEFT", 
          LBL_START_POSITION = "", 
          LBL_NUM_OF_CHARS = "",
          LBL_PARSE_FROM = "LEFT", 
          LBL_START_VAL = "", 
          LBL_END_VAL = "",
          LBL_START_OCCUR = "",
          LBL_END_OCCUR = ""} = value;
      const enableSubStr = LBL_PARSE_FROM &&
      LBL_START_VAL &&
      LBL_END_VAL &&
      LBL_START_OCCUR > -1 &&
      LBL_END_OCCUR > -1;
      return {
          SUBSTRING: enableSubStr ? [
              LBL_PARSE_FROM,
              LBL_START_VAL,
              LBL_END_VAL,
              LBL_START_OCCUR,
              LBL_END_OCCUR].filter(val => val?.length > 0).join("%1F") : "",
          LBL_PARSE_FROM,
          LBL_START_VAL,
          LBL_END_VAL,
          LBL_START_OCCUR,
          LBL_END_OCCUR,
          PORTIONING_TYPE: "BTN_NONE",
          readOnly,
          LBL_FROM, 
          LBL_START_POSITION, 
          LBL_NUM_OF_CHARS 
      }
  }
    
}

const rmDataTransformer = {
    toRecordMap: (val, index,FILETYPE) => {
        const newVal = {
            key: `rmp-${index}`,
            title: val?.NAME || 'UNNAMED',
            ICON_DISPLAY: 'RECORD_MAPPING',
            TYPE: 'RECORD_MAPPING',
            COMPARE: val?.COMPARE || "EMPTY",
            COMPARE_ACTION_IGNORECASE: val?.COMPARE_ACTION_IGNORECASE || "FALSE",
            COMPARE_ACTION_NOT: val?.COMPARE_ACTION_NOT || "FALSE",
            COMPARE_ACTION_TRIM: val?.COMPARE_ACTION_TRIM || "FALSE",
            FIELD_NAME: val?.FIELD_NAME || "",
            FIELD_OUTLINE_LEVEL: val?.FIELD_OUTLINE_LEVEL || "",
            FIELDNUM: val?.FIELDNUM || "",
            LEVEL: FILETYPE === "NVP" ? 'RECORD' : val?.LEVEL || "FIELD",
            MAPNAME: val?.MAPNAME || "",
            NAME: val?.NAME || "UNNAMED",
            RECORDTYPE: val?.RECORDTYPE || "",
            VALUE: val?.VALUE || "",
            ...(val?.COMPARE === "IS_DATE" ?
            {PATTERN: val?.PATTERN === undefined ? "MM/dd/yy" : val?.PATTERN || ''} : {PATTERN: val?.PATTERN === undefined ? "MM/dd/yy" : val?.PATTERN || ''}),
            ...(val?.LEVEL === "RECORD" || FILETYPE==="NVP"? 
            {SUBSTRING: val?.SUBSTRING || "",
            PORTIONING_TYPE: val?.PORTIONING_TYPE || "BTN_NONE",
            LBL_TEST_DATA: val?.LBL_TEST_DATA || "",
            ...transformSubstring(val || "", val?.readOnly)} : {}),
        }
        return newVal;
    },
    toCompoundRecordMap: (val, pIndex, sIndex, FILETYPE) => {
        return {
            key: `${pIndex}-${sIndex}`,
            title: val?.NAME || `UNNAMED${sIndex + 1}`,
            ICON_DISPLAY: 'RECORD_MAPPING',
            TYPE: 'COMPOUND_RECORD_MAPPING',
            COMPARE: val?.COMPARE || "EMPTY",
            COMPARE_ACTION_IGNORECASE: val?.COMPARE_ACTION_IGNORECASE || "FALSE",
            COMPARE_ACTION_NOT: val?.COMPARE_ACTION_NOT || "FALSE",
            COMPARE_ACTION_TRIM: val?.COMPARE_ACTION_TRIM || "FALSE",
            FIELD_NAME: val?.FIELD_NAME || "",
            FIELDNUM: val?.FIELDNUM || "",
            LEVEL: FILETYPE === "NVP" ? 'RECORD' : val?.LEVEL || "FIELD",
            MAPNAME: val?.MAPNAME || "",
            NAME: val?.NAME || `UNNAMED${sIndex + 1}`,
            SUBSTRING: val?.SUBSTRING || "",
            OPERATOR: val?.OPERATOR || "AND",
            RECORDTYPE: val?.RECORDTYPE || "",
            VALUE: val?.VALUE || "",
            ...(val?.COMPARE === "IS_DATE" ?
            {PATTERN: val?.PATTERN === undefined ? "MM/dd/yy" : val?.PATTERN || ''} : {PATTERN: val?.PATTERN === undefined ? "MM/dd/yy" : val?.PATTERN || ''}),
            ...(val?.LEVEL === "RECORD" ? 
            {SUBSTRING: val?.SUBSTRING || "", 
            PORTIONING_TYPE: val?.PORTIONING_TYPE || "BTN_NONE",
            LBL_TEST_DATA: val?.LBL_TEST_DATA || "",
            ...transformSubstring(val || "", val?.readOnly)} : {}),
        }
    },
    toCompoundMap: (val, key, type, filetype) => {
        const condition = val?.CONDITION?.map((condition, sIndex) => {
            if(condition?.CONDITION){
                return rmDataTransformer.toCompoundMap(condition, `${key}-${sIndex}`, 'COMPOUND_COMPOUND_MAPPING')
            }
            return rmDataTransformer.toCompoundRecordMap(condition, key, sIndex, filetype);
        });
        return {
            key,
            title: val?.NAME + " (" + val?.CHILDOPERATOR + ")" || `COMPOUND CONDITION`,
            ICON_DISPLAY: 'NETWORK_FOLDER',
            TYPE: type || 'COMPOUND_MAPPING',
            COMPARE_ACTION_IGNORECASE: val?.COMPARE_ACTION_IGNORECASE ||  "FALSE",
            COMPARE_ACTION_NOT: val?.COMPARE_ACTION_NOT || "FALSE",
            COMPARE_ACTION_TRIM: val?.COMPARE_ACTION_TRIM || "FALSE",
            NAME: val?.NAME || `COMPOUND CONDITION ${val?.CHILDOPERATOR}`,
            RECORDTYPE: val?.RECORDTYPE || "",
            VALUE: val?.VALUE || "",
            CHILDOPERATOR: val?.CHILDOPERATOR || "AND",
            children: condition,
            CONDITION: condition
          }
    },
    toRCTree: (conditions,filetype) => {
        return conditions?.map((condition, index) => {
            if(condition.CONDITION)
                return rmDataTransformer.toCompoundMap(condition, `rmp-${index}`, filetype);
            return rmDataTransformer.toRecordMap(condition, index, filetype);
        })
    } 
}

export const isDuplicateName = (tree,name,node) =>{
      const body = tree['body'].translatedData;
      const header = tree['header'].translatedData;
      const trailer = tree['trailer'].translatedData;
      let found = false;
      const iterateTree = (data) => {
        data.forEach(ele=>{
          if(ele?.key !== node?.key && ele?.ICON_DISPLAY === node?.ICON_DISPLAY && ele?.TYPE === name){
            found = true;
            return;
          }
          if(ele?.children?.length){
            iterateTree(ele?.children);
          }
        })
        if(found){
          return found;
        }
      }

      iterateTree(body);
      iterateTree(header);
      iterateTree(trailer);
      return found;
    }